export default "__VITE_ASSET__VaoKYcyh__"